import {IReduxState} from "reducers";
import {ScreenNames} from "IncompleteInfoV2/utils";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";
import {IBankStatementStatus} from "StateInterface";
import * as React from "react";
import {useEffect, useState} from "react";
import {BsModes, Modes} from "IncompleteInfoV2/BankStatementV2/BSModes";
import {BS_SUB_STATUS} from "IncompleteInfoV2/BankStatementV2/utils";
import ContainerBox from "myshubhlife-component/container-box";
import {Loading} from "web-com";
import BankSelection from "IncompleteInfoV2/BankStatementV2/BankSelection";
import {fetchBankStatementStatus, getAccAggregatorLink} from "IncompleteInfoV2/api";
import {setBankStatementStatus} from "IncompleteInfoV2/actions";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    bankStatementsStatus: {is_bs_upload_allowed: boolean};
    subStatus: string[];
    applicationId: number;
    utm_source?: string;
    apiVersion: number;
}
export interface IBankDetails {
    name: string;
    id: string;
    isNetBanking: boolean;
}

export interface IAggregatorDetails {
    live: boolean;
    type?: string;
    value?: string;
}

const BankStatementV2 = (props: IConnectProps & RouteComponentProps) => {
    const getBankDetails = () => {
        const details = JSON.parse(sessionStorage.getItem("aggregator_details"));
        if (!details) return null;
        return {
            id: details.id,
            name: details.name,
            isNetBanking: details.isNetBanking,
        };
    };
    const [modesToRender , setModesToRender] = useState([Modes.NET_BANKING, Modes.PDF_UPLOAD]);
    const [isBankSelectionRequired, setIsBankSelectionRequired] = useState(true);
    const [bankDetails, setBankDetails] = useState<IBankDetails>(null);
    const [aggregatorDetails, setAggregatorDetails] = useState<string>(null);
    const [loading, setLoading] = useState(true);
    const sessionAggregatorDetails = JSON.parse(sessionStorage.getItem("aggregator_details"));

    useEffect(() => {
        (async () => {
            try {
                const res = await fetchBankStatementStatus();
                props.dispatch(setBankStatementStatus(res));
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    useEffect(() => {
        if (props.bankStatementsStatus && props.subStatus) {
            if (props.subStatus.includes(BS_SUB_STATUS.BS_NET_BANKING)) {
                setModesToRender([Modes.NET_BANKING]);
            } else if (props.subStatus.includes(BS_SUB_STATUS.BS_PDF_NET_AA)) {
                if (sessionAggregatorDetails) {
                    sessionAggregatorDetails?.isNetBanking ?
                        setModesToRender([Modes.NET_BANKING, Modes.PDF_UPLOAD]) :
                        setModesToRender([Modes.PDF_UPLOAD]);
                }
            } else if (!props.bankStatementsStatus.is_bs_upload_allowed) {
                setIsBankSelectionRequired(false);
                setModesToRender([Modes.GOOGLE_FORM]);
            }
            setLoading(false);
        }
        if (sessionAggregatorDetails) {
           setBankDetails(getBankDetails());
        }
    }, [props.bankStatementsStatus, props.subStatus]);
    const getAggregatorLink = async (bankId: string, isNetBanking: boolean) => {
        setLoading(true);
        try {
            const res = await getAccAggregatorLink(bankId, props.applicationId);
            if (res?.live) {
                setModesToRender([Modes.BS_PDF_NET_AA]);
                setAggregatorDetails(res?.value);
            } else {
                isNetBanking ? setModesToRender([Modes.NET_BANKING, Modes.PDF_UPLOAD]) :
                setModesToRender([Modes.PDF_UPLOAD]);
            }
        } catch (error) {
            isNetBanking ? setModesToRender([Modes.NET_BANKING, Modes.PDF_UPLOAD]) :
                setModesToRender([Modes.PDF_UPLOAD]);
        }
        setLoading(false);
    };

    const onBankSelection = (id: string, name: string, isNetBanking: boolean) => {
        if (!isNetBanking) {
            const index = modesToRender.indexOf(Modes.NET_BANKING);
            if (index > -1) {
                const modesList = modesToRender;
                modesList.splice(index, 1);
                setModesToRender(modesList);
            }
        }
        if (!sessionAggregatorDetails && props.subStatus.includes(BS_SUB_STATUS.BS_PDF_NET_AA)) {
            getAggregatorLink(id, isNetBanking);
        }
        setBankDetails({id, name, isNetBanking});
    };
    return(
        <ContainerBox  showBackButton={!props.isAndroid} pageTitle="Bank statement upload">
            <Loading msg="Please wait" active={loading}/>
            {isBankSelectionRequired &&
                <BankSelection
                  bankDetails={bankDetails || getBankDetails()}
                  onChangeHandler={onBankSelection}
                  disabled={!!bankDetails || !!sessionAggregatorDetails}
                />
            }
            {!loading && (bankDetails || modesToRender.includes(Modes.GOOGLE_FORM)) &&
                <BsModes
                  bsModes={modesToRender}
                  userId={props.userId}
                  bankDetails={bankDetails}
                  isAllowedToUpload={props.bankStatementsStatus && props.bankStatementsStatus.allowBsUpload}
                  applicationId={props.applicationId}
                  onboardEmailRequired={!(props.subStatus && props.subStatus.includes(BS_SUB_STATUS.BS_NET_BANKING))}
                  utm_source={props.utm_source}
                  aggregatorDetail={aggregatorDetails}
                  isAndroid={props.isAndroid}
                  apiVersion={props.apiVersion}
                />
            }
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        bankStatementsStatus: state?.incompleteInfoV2?.bankStatementsStatus,
        subStatus: state.incompleteInfoV2.screens &&
        state.incompleteInfoV2.screens[ScreenNames.BANK_STATEMENT] ?
            state.incompleteInfoV2.screens[ScreenNames.BANK_STATEMENT].subStatuses : null,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
        apiVersion: state.login.apiVersion,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(BankStatementV2);
